import { Named } from '../base/named';
import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';

@Metamodel.model({
    name: 'type-conversion-settings'
})
export class TypeConversionSettings extends Named {
    public static readonly MODEL: IModel;
    public static readonly ALLOW_DATA_TRUNCATION: IAttribute;
    public static readonly TREAT_BOOLEAN_AS_NUMBER: IAttribute;
    public static readonly DATE_FORMAT: IAttribute;
    public static readonly DATETIME_FORMAT: IAttribute;
    public static readonly DATETIME_OFFSET_FORMAT: IAttribute;
    public static readonly TIME_SPAN_FORMAT: IAttribute;
    public static readonly TIME_FORMAT: IAttribute;
    public static readonly CULTURE: IAttribute;

    @Metamodel.attribute({
        display: stringResources.TypeConversion_AllowDataTruncation_Label,
        templatable: true,
        association: 'ALLOW_DATA_TRUNCATION'
    })
    public allowDataTruncation: boolean = true;

    @Metamodel.attribute({
        display: stringResources.TypeConversion_TreatBooleanAsNumber_Label,
        templatable: true,
        association: 'TREAT_BOOLEAN_AS_NUMBER'
    })
    public treatBooleanAsNumber: boolean = false;

    @Metamodel.attribute({
        display: stringResources.DateFormat_Label,
        templatable: true,
        association: 'DATE_FORMAT'
    })
    public dateFormat: string;

    @Metamodel.attribute({
        display: stringResources.TypeConversion_DatetimeFormat_Label,
        templatable: true,
        association: 'DATETIME_FORMAT'
    })
    public dateTimeFormat: string;

    @Metamodel.attribute({
        display: stringResources.TypeConversion_DatetimeOffsetFormat_Label,
        templatable: true,
        association: 'DATETIME_OFFSET_FORMAT'
    })
    public dateTimeOffsetFormat: string;

    @Metamodel.attribute({
        display: stringResources.TypeConversion_TimeSpanFormat_Label,
        templatable: true,
        association: 'TIME_SPAN_FORMAT'
    })
    public timeSpanFormat: string;

    @Metamodel.attribute({
        display: stringResources.TypeConversion_TimeFormat_Label,
        templatable: true,
        association: 'TIME_FORMAT'
    })
    public timeFormat: string;

    @Metamodel.attribute({
        display: stringResources.Schema_Culture_Label,
        templatable: true,
        association: 'CULTURE'
    })
    public culture: string;
}
